import Vue from 'vue'
import Vuex from 'vuex'
import getter from './getter'
Vue.use(Vuex);

/*
* require.context(directory, boolean, regExp)
*
* */
const files = require.context('./modules', false, /\.js$/);
const modules = {};
files.keys().forEach((key) => {
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
});
const store = new Vuex.Store({
  modules,
  getters: getter
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js